import AppSync from "@/services/AppSync"
import AppSyncNotification from "@/types/AppSyncNotification.interface"

interface State {
    appSyncNotifications: AppSyncNotification[]
}

const defaults = () => {
    return {
        appSyncNotifications: []
    }
}
export default {
    state: defaults(),
    mutations: {
        appSyncNotificationsPush (state: State, appSyncNotifs: AppSyncNotification[]): void {
            //  Push this into our list
            state.appSyncNotifications = window.removeDuplicatesById(state.appSyncNotifications, appSyncNotifs)

            //  Sort our notifications by their created_at
            state.appSyncNotifications.sort((a: AppSyncNotification, b: AppSyncNotification) => {
                //  @ts-ignore
                return +window.getDate(b.created_at) - +window.getDate(a.created_at)
            })
        },
        appSyncNotificationsReset (state: State): void {
            Object.assign(state, defaults())
        },
        appSyncNotificationsSet (state: State, appSyncNotifs: AppSyncNotification[]): void {
            state.appSyncNotifications = appSyncNotifs
        }
    },
    actions: {
        appSyncNotificationsGet ({commit, getters}): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/appsync`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our roles in the store
                commit('appSyncNotificationsSet', response.data)

                //  Return true since this was successful
                return true
            }).catch(() => null)
        },
        appSyncUpdate ({ commit, getters }, id: string): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/appsync/update`

            //  Send the request
            return window.axios.put(url, {id: id}).then(response => {
                //  Update our app sync
                commit('appSyncNotificationsPush', response.data)

                //  Trigger our onAppSyncLoaded event
                AppSync.onAppSyncNotificationsRefreshed(response.data)

                //  Return true for success
                return true
            }).catch(() => null)
        }
    },
    getters: {
        //  Get all available roles
        appSyncNotifications (state: State): AppSyncNotification[] {
            return state.appSyncNotifications
        },
        latestAppSync (state: State): AppSyncNotification {
            //  Grab all of our app sync notifications
            const notifs = state.appSyncNotifications

            //  We only want the most recent one
            return notifs[0]
        }
    }
}